import vehicles from '../../../services/vehicles';
import messageDialog from '../../../components/message-dialog';
import axios from 'axios';
import C from '../constantes';
import * as obj from './objects';
import {isCaminhoParana} from '../../../utils';
import {EventBus} from '../../../event-bus';
//FIXME: Solução temporária para tratar promoção do dias das mães.
import {mapGetters} from 'vuex';

export default {

  props: [
    'vehicles',
    'type',
    'allowVehicles',
    'planId'
  ],

  data() {
    return {
      // * Dados da placa
      plate: '',

      // * Dados do modelo
      models: [],
      modelSelected: {},
      modelId: undefined,

      // * Dados da marca
      brands: undefined,
      brandSelected: {},
      brandId: undefined,

      // * Dados do eixo
      axesName: "",
      axesId: 1,
      errorMessage:undefined,
      loading: undefined,

      // * Steps do formulário
      formStep: 0,

      // * Dados de transportador / RNTRC do veículo atual
      isTransportador: false,
      cpfCnpjTransportador: undefined,

      //* Condição booleana para mostrar o modal
      showModalInvalidPlate: false,

      //* Condição booleana para mostrar a tela de loading
      loading: false,

      formVisibility: false
    }
  },

  computed: {
    //FIXME: Solução temporária para tratar promoção do dias das mães.
    ...mapGetters(['getPromotionCurrent']),

    isAdhesionAditional(){
      return this.$route.path.indexOf('/veiculos/novo') >=0;
    },
    //FIXME: Solução temporária para tratar promoção do dias das mães.
    lead(){
      return this.$parent.lead;
    },
  },

  mounted() {
    if (this.vehicles && this.vehicles.length) {
      this.formStep = 1;
    }
  },

  methods: {

    // * Funções para mudar as variaveis pelo filho
    ChangeByPropsStepOne(plateSelected, brandNameSelected, brandIdSelected, arrayModelsByNetrin) {
      this.plate                  = plateSelected;
      this.brandSelected.brandId  = brandIdSelected;
      this.brandSelected.name     = brandNameSelected;
      this.models                 = arrayModelsByNetrin;
      return;
    },
    ChangeByPropsStepOneNetrinOff(plateSelected, brandNameSelected, brandIdSelected, modelSelected, modelSelectedId) {
      this.plate                  = plateSelected;
      this.brandSelected.brandId  = brandIdSelected;
      this.brandSelected.name     = brandNameSelected;
      this.modelSelected.name     = modelSelected;
      this.modelSelected.modelId  = modelSelectedId;
      return;
    },
    ChangeModelInfo(modelName, modelId) {
      this.modelSelected.name     = modelName;
      this.modelSelected.modelId  = modelId;
      return;
    },
    ChangeAxesInfo(axesName, axesId) {
      this.axesId   = axesId;
      this.axesName = axesName;
      return;
    },
    ChangeTransportadorInfo(isTransportador, cpfCnpjTransportador) {
      this.isTransportador      = !!isTransportador;
      this.cpfCnpjTransportador = cpfCnpjTransportador || undefined;
      return;
    },

    // * Função para ligar/desligar o loading
    ChangeLoadingStatusToOn() {
      return this.loading = true;
    },
    ChangeLoadingStatusToOff() {
      return this.loading = false;
    },

    // * Função para mostrar o form
    OpenForm() {
      this.formVisibility = true;
      return;
    },

    // * Função para voltar para o passo 0
    stepBackZero() {
      return this.formStep = 0;
    },

    unphenize(plates){
      var response = [];
      plates.forEach(plate => {
         response.push(plate.replace("-",""));
      });
      return response;
    },

    // * Função para adicionar vehicle
    add() {
      this.loading      = true;
      let vm            = this;
      this.errorMessage = undefined;
      vm.errors.clear();

      if( !isCaminhoParana(this.planId) && this.allowVehicles >= 0 && vm.vehicles.length >= this.allowVehicles){
        messageDialog.show({
          title: `Limite atingido` ,
          message: `Este plano permite adicionar apenas ${C.LIMIT_VEHICLES} veículos`,
          type: 'OK'
        });
        return this.loading = false;
      }

      if( (this.planId == 21 || this.planId == 22 || this.planId == 28) && vm.vehicles.length >= 10){
        messageDialog.show({
          title: `Limite atingido` ,
          message: `Este plano permite adicionar apenas 10 veículos`,
          type: 'OK'
        });
        return this.loading = false;
      }

      // //FIXME: Solução temporária para tratar promoção do dias das mães.
      // if(this.getPromotionCurrent.promotion_code == '#MAE50' && vm.vehicles.length == 1 && !this.isAdhesionAditional && this.planId != 33){
      //   return;
      // };
      // //FIXME: Solução temporária para tratar promoção do dias das mães.
      let promises = []
      promises.push(vehicles.vehicleNotExists(this.plate));

      if(this.lead && this.lead.plates.length > 0){
        let promiseLead = new Promise((resolve,reject)=>{

          this.lead.plates=this.unphenize(this.lead.plates);

          if(this.lead.plates.indexOf(this.plate.replace("-","").toUpperCase()) >= 0)
            resolve(true);
          else
            reject('Veiculo não esta cadastrado no plano Caminhos do Paraná!');
        });

        promises.push(promiseLead);
      }

      let v = obj.vehicle();

      v.plate                       = vm.plate.toUpperCase();
      v.model.modelId               = vm.modelSelected.modelId;
      v.model.name                  = vm.modelSelected.name;
      v.model.brand.brandId         = vm.brandSelected.brandId;
      v.model.brand.name            = vm.brandSelected.name;
      v.categoryAxes.categoryAxesId = vm.axesId;
      v.categoryAxes.name           = vm.axesName;
      v.isTransportador             = vm.isTransportador;
      v.cpfCnpjTransportador        = vm.isTransportador ? vm.cpfCnpjTransportador : undefined;

      vm.vehicles.push(v);
      vm.plate                  = '';
      vm.isTransportador        = false;
      vm.cpfCnpjTransportador   = undefined;
      vm.formStep               = 1;
      vm.formVisibility         = false;
      vm.loading                = false;
      vm.$forceUpdate();
      EventBus.$emit('cleanErrors');

    },
  }

}



// WEBPACK FOOTER //
// ./src/pages/common/adhesion/vehicles.js